@if (icon(); as icon) {
  <ui-icon [faName]="icon" class="theme-icon" faStyle="light"></ui-icon>
}

@if (message(); as message) {
  <div uiPageBlockImpression [innerHTML]="message" class="message" uiHtmlDataLink></div>
}

@if (showIconClose()) {
  <button (click)="close()" mat-icon-button>
    <ui-icon faName="xmark" faStyle="light"></ui-icon>
  </button>
}
